import { render, staticRenderFns } from "./details2.vue?vue&type=template&id=1c82a1f6&scoped=true&"
import script from "./details2.vue?vue&type=script&lang=js&"
export * from "./details2.vue?vue&type=script&lang=js&"
import style0 from "./details2.vue?vue&type=style&index=0&id=1c82a1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82a1f6",
  null
  
)

export default component.exports